<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <TransitionRoot
    as="template"
    :show="open"
  >
    <Dialog
      as="div"
      class="fixed inset-0 z-10 overflow-y-auto"
      @close="() => {}"
    >
      <div
        class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 transition-opacity bg-gray-500/75" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >&#8203;</span>
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="relative inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6"
          >
            <div>
              <div
                class="flex items-center justify-center w-6 h-6 mx-auto bg-gray-100 rounded-full"
              >
                <ld-icon
                  icon="PauseIcon"
                  class="w-6 h-6 text-gray-600"
                  aria-hidden="true"
                />
              </div>
              <div
                class="flex items-center justify-center w-6 h-6 mx-auto text-gray-500 bg-gray-100 rounded-full"
              >
                {{ duration }}
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <DialogTitle
                  as="h3"
                  class="text-lg font-medium leading-6 text-gray-900"
                >
                  You Are Currently on {{ auth.pause?.attributes.name }}
                </DialogTitle>
                <!-- <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Consequatur amet labore.
                  </p>
                </div> -->
              </div>
            </div>
            <div class="mt-5 sm:mt-6">
              <button
                type="button"
                class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-teal-600 border border-transparent rounded-md shadow-sm hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-real-500 sm:text-sm"
                @click="close"
              >
                Resume
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import { defineComponent, onMounted, onUnmounted, Ref, ref, watch } from 'vue'
  import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  } from '@headlessui/vue'
  import useLetsDialSocket from '/@/services/letsDialSocket/useLetsDialSocket'
  import { useAuthStore } from '/@/store/authStore'
  import { DateTime } from 'luxon'
  const props = withDefaults(defineProps<{ open: boolean }>(), {
    open: () => false,
  })
  const auth = useAuthStore()
  const duration = ref('')
  let timeInterval: any
  let start: Ref<DateTime | undefined> = ref(undefined)

  watch(
    () => props.open,
    (val) => {
      if (val) {
        start.value = DateTime.now()
        timeInterval = setInterval(() => {
          if (start.value) {
            const diff = DateTime.now().diff(start.value)
            if (diff.hours > 0) {
              duration.value = diff.toFormat('HH:mm:ss')
            } else {
              duration.value = diff.toFormat('mm:ss')
            }
          }
        }, 1000)
      } else {
        start.value = undefined
        clearInterval(timeInterval)
      }
    },
  )
  // const open = ref(true)
  // return {
  //   open,
  // }
  const { socket } = useLetsDialSocket()
  onMounted(() => {
    start.value = DateTime.now()
    timeInterval = setInterval(() => {
      if (start.value) {
        const diff = DateTime.now().diff(start.value)
        if (diff.hours > 0) {
          duration.value = diff.toFormat('HH:mm:ss')
        } else {
          duration.value = diff.toFormat('mm:ss')
        }
      }
    }, 1000)
  })
  onUnmounted(() => {
    start.value = undefined
    clearInterval(timeInterval)
  })
  const close = () => {
    auth.setPause(undefined)
    start.value = undefined
    clearInterval(timeInterval)
    auth.setAvailabilityStatus('IDLE', true)
  }
</script>
